import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
    phone?: any
};

export const getMessage = ({ phone }: requestDTO) => {
    return axios.post(`/superadmin/get-message`, { phone });
};

type UseAddUserOptions = {
    config?: MutationConfig<typeof getMessage>;
};

export const useGetMessage = ({ config }: UseAddUserOptions = {}) => {
    const { addNotification } = useNotificationStore();
    return useMutation({
        onSuccess: () => {
            // showNotification({
            //     type: 'success',
            //     title: 'Messsage sent successfully',
            // });
        },
        ...config,
        mutationFn: getMessage,
    });
};
